import {
  FormBuilderMetaFlags,
  ICreateWidgetFormSchemaInput,
  createEvaluationVariables,
  mapReferenceToPath,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { ICompetenceWidget } from './ICompetenceWidget';

export function competenceSelectWidgetLabelName(code: string) {
  return `${code}@label`;
}

export const WidgetCompetenceFormSchemaMetaFlag = 'isCompetenceWidget';

export function createCompetenceSelectFormSchema(
  input: ICreateWidgetFormSchemaInput<ICompetenceWidget>,
) {
  const { widget } = input;

  const reference = widget.sourceValueReference;

  let widgetSchema = yup
    .string()
    .meta({ [WidgetCompetenceFormSchemaMetaFlag]: true });

  // Se è richiesta la reference, impostiamo forzatamente il valore del campo
  if (reference) {
    const path = mapReferenceToPath(reference);
    widgetSchema = widgetSchema.parentWhen(
      [path],
      (values, schema: yup.AnySchema, context: any) => {
        const variables = createEvaluationVariables([reference], values);
        const value = variables[reference.id];
        return schema.default(value ?? null).transform(() => value);
      },
    );
  }

  const labelSchema = yup
    .string()
    .notRequired()
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );

  return {
    [widget.code]: widgetSchema.notRequired(),
    [competenceSelectWidgetLabelName(widget.code)]: labelSchema.notRequired(),
  };
}
